var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackToTopArrowBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.324,
    height: 16.814,
    viewBox: "0 0 13.324 16.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-up",
    "data-name": "Icon awesome-arrow-up",
    d: "M1.29,10.106.612,9.429a.729.729,0,0,1,0-1.035L6.542,2.462a.729.729,0,0,1,1.035,0l5.929,5.929a.729.729,0,0,1,0,1.035l-.677.677a.733.733,0,0,1-1.047-.012l-3.5-3.674V18.328a.731.731,0,0,1-.732.732H6.572a.731.731,0,0,1-.732-.732V6.417l-3.5,3.677a.728.728,0,0,1-1.047.012Z",
    transform: "translate(-0.397 -2.246)",
    fill: "#0b70d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTopArrowBlue);
export default __webpack_public_path__ + "static/media/back-to-top-arrow-blue.2721c39ee912ddc27fa2c7a26b5ae53f.svg";
export { ForwardRef as ReactComponent };